div(v-if='slots.link' @click='login' data-test='login.slot')
  slot(name='link')
FairplayerButtonVue(v-else icon='log-in' :expand='expandButton' :text='t(translateKey)' @click='login' data-test='login.button')
